import { useContext } from 'react';
import { Container } from 'react-bootstrap';
import { Navigate, Outlet } from 'react-router-dom';

import { AuthContext } from '../../contexts/AuthContext';

const AuthRoute = () => {
  const { isAPIAuthenticated, isLoggedIn } = useContext(AuthContext);

  if (!isLoggedIn) return <></>;

  if (isLoggedIn === true && isAPIAuthenticated === true) {
    return (
      <Container fluid className="p-0 h-100 w-100" style={{ maxHeight: '100%', overflow: 'auto' }}>
        <Outlet />
      </Container>
    );
  } else if (isLoggedIn === true) {
    return <Navigate to="/verify" />;
  }
  return <Navigate to="/login" />;
};

export default AuthRoute;
